import type { I18nFn } from '#/i18n/types/I18nFn';

export function USER_FLAGGING_REASONS(i18n: I18nFn) {
  return [
    {
      id: 'SCAM_SPAM',
      description: i18n('Content shared is spam/a scam'),
    },
    {
      id: 'ABUSIVE_HARASSING',
      description: i18n('Content shared is abusive/harassing'),
    },
    {
      id: 'OTHER',
      description: i18n('Other'),
    },
  ];
}
